var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCardEuxp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2800.0002441 2160",
    style: {
      enableBackground: "new 0 0 2800.0002441 2160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.05
    },
    fill: "#fff",
    points: "2187.9970703,1079.9973145 2800.0002441,0 2656.0056152,0 2043.9957275,1079.9973145 2656.0002441,2160 2800.0002441,2160 "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD00",
    d: "M1575.9919434,0h-143.9945068H0.0000578v2160h1575.9919434l0,0h0.0054932l611.9991455-1080.0026855 L1575.9919434,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCardEuxp);
export default __webpack_public_path__ + "static/media/x-card-euxp.80732401bbb743c698908fba511f0276.svg";
export { ForwardRef as ReactComponent };